import { graphql } from "gatsby"
import React, { Fragment } from "react"
import { Helmet } from "react-helmet"
import rehypeReact from "rehype-react"
import styled from "styled-components"
import Banner from "../components/Banner"
import Container from "../components/Container"
import Navbar from "../components/Navbar/Navbar"
import { LoginStateContextProvider } from "../contexes/LoginStateContext"
import PagesContext from "../contexes/PagesContext"
import getNamedPartials from "../partials"
import Layout from "./Layout"
import "./remark.css"

const ContentWrapper = styled.article`
  h1 {
    font-family: "Josefin Sans", sans-serif;
    font-weight: 600;
    font-size: clamp(28px, 3vw, 4rem);
    color: #333;
  }
`

export default class InfoPageTemplate extends React.Component {
  render() {
    const { data } = this.props
    const { frontmatter, htmlAst } = data.page
    const partials = getNamedPartials()
    const renderAst = new rehypeReact({
      createElement: React.createElement,
      components: partials,
    }).Compiler

    const filePath = data.page.fileAbsolutePath.substring(
      data.page.fileAbsolutePath.lastIndexOf("/data/"),
      data.page.fileAbsolutePath.length,
    )
    return (
      <Fragment>
        <Helmet title={frontmatter.title} />
        <PagesContext.Provider
          value={{
            all: data,
            current: { frontmatter: frontmatter, filePath: filePath },
          }}
        >
          <LoginStateContextProvider>
            <Layout>
              <Fragment>
                {frontmatter.banner && <Banner />}
                <Navbar> </Navbar>
                <Container>
                  <ContentWrapper>
                    <h1>{frontmatter.title}</h1>
                    {renderAst(htmlAst)}
                  </ContentWrapper>
                </Container>
              </Fragment>
            </Layout>
          </LoginStateContextProvider>
        </PagesContext.Provider>
      </Fragment>
    )
  }
}

export const pageQuery = graphql`
  query ($path: String!) {
    page: markdownRemark(frontmatter: { path: { eq: $path } }) {
      htmlAst
      html
      frontmatter {
        path
        title
        banner
      }
      fileAbsolutePath
    }
    allPages: allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            path
            title
          }
        }
      }
    }
  }
`
